// @flow

import { Environment } from 'relay-runtime';
import { commitMutation, graphql } from 'react-relay';

const mutation = graphql`
    mutation TVShowEpisodeEditMutation(
    $input: TVShowEpisodeEditInput!
    ) {
        TVShowEpisodeEdit(input: $input) {
            tVShowEpisode {
                id
            }
        }
    }
`;

export function commit(environment: Environment, params: any, callback: (error: ?Error, id: ?string) => void) {
    commitMutation(
        environment,
        {
            mutation,
            variables: {
                input: params,
            },
            onCompleted: (response) => {
                if (response.error !== null && response.error !== undefined) {
                    callback(response.error, null);
                    return;
                }

                if (callback) {
                    if (response.TVShowEpisodeEdit && response.TVShowEpisodeEdit.hasOwnProperty('tVShowEpisode') &&
                        response.TVShowEpisodeEdit.tVShowEpisode.hasOwnProperty('id')) {
                        callback(null, response.TVShowEpisodeEdit.tVShowEpisode.id);
                    }
                }
            },
            onError: (error) => {
                if (callback) {
                    callback(error, null);
                }
            },
        },
    );
}



// WEBPACK FOOTER //
// src/mutations/TVShowEpisodeEditMutation.js